import WithLoadable from 'components/WithLoadable';

export default WithLoadable(() => import(/* webpackChunkName: "login-page" */ './index'));
